import React from "react";
import { useLang } from "@/contexts/LangContext";
import { LOGO_URL } from "@/i18n";
import { Phone, Mail, MessageCircle, ExternalLink } from "lucide-react";

export default function Footer({ onOpenLead }) {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="relative pt-20 pb-10 border-t border-white/8 bg-[#08101e]">
      <div className="mx-auto max-w-7xl px-5">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-10">
          <div className="lg:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <img src={LOGO_URL} alt="Reinvente" className="h-10 w-10 rounded-full ring-1 ring-white/15" />
              <div className="flex flex-col leading-none">
                <span className="font-display text-base font-extrabold tracking-tight text-white">Reinvente</span>
                <span className="text-[10px] uppercase tracking-[0.22em] text-white/45 font-mono-tight">
                  Mercadeo & Coaching Comercial
                </span>
              </div>
            </a>
            <p className="mt-5 text-[14px] text-white/55 leading-relaxed max-w-md">{t.footer.tagline}</p>

            <button
              onClick={onOpenLead}
              data-testid="footer-cta-button"
              className="mt-7 inline-flex items-center gap-2 px-5 py-3 rounded-full text-sm font-semibold text-white btn-primary-glow"
            >
              {t.cta.button}
            </button>
          </div>

          <div className="lg:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.22em] text-white/40 font-mono-tight mb-4">
              {t.footer.explore}
            </div>
            <ul className="space-y-2.5 text-[14px]">
              <li>
                <a href="https://reinventemercadeo.com/servicios/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-white/70 hover:text-white transition">
                  {t.nav.services} <ExternalLink className="h-3 w-3 opacity-50" />
                </a>
              </li>
              <li><a href="#portfolio" className="text-white/70 hover:text-white transition">{t.nav.cases}</a></li>
              <li>
                <a href="https://reinventemercadeo.com/acerca-de/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-white/70 hover:text-white transition">
                  {t.nav.about} <ExternalLink className="h-3 w-3 opacity-50" />
                </a>
              </li>
              <li><a href="#process" className="text-white/70 hover:text-white transition">{t.nav.process}</a></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.22em] text-white/40 font-mono-tight mb-4">
              {t.footer.contact}
            </div>
            <ul className="space-y-3 text-[14px]">
              <li>
                <a href="mailto:info@reinventemercadeo.com" className="inline-flex items-center gap-2 text-white/70 hover:text-white transition">
                  <Mail className="h-4 w-4" /> info@reinventemercadeo.com
                </a>
              </li>
              <li>
                <a href="tel:+573043381885" className="inline-flex items-center gap-2 text-white/70 hover:text-white transition">
                  <Phone className="h-4 w-4" /> +57 304 338 1885
                </a>
              </li>
              <li>
                <a href="https://wa.me/573043381885" target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="inline-flex items-center gap-2 text-white/70 hover:text-white transition">
                  <MessageCircle className="h-4 w-4 text-brand-orange" /> {t.footer.whatsapp}
                </a>
              </li>
            </ul>
            <div className="mt-5">
              <p className="text-[13px] text-white/50">Santiago de Cali, Colombia</p>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.22em] text-white/40 font-mono-tight mb-4">
              {t.footer.legal}
            </div>
            <ul className="space-y-2.5 text-[14px]">
              <li>
                <a href="https://reinventemercadeo.com/contacto/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-white/70 hover:text-white">
                  Contacto <ExternalLink className="h-3 w-3 opacity-50" />
                </a>
              </li>
              <li>
                <a href="https://reinventemercadeo.com/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-white/70 hover:text-white">
                  reinventemercadeo.com <ExternalLink className="h-3 w-3 opacity-50" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/8 flex flex-col md:flex-row gap-3 items-start md:items-center justify-between">
          <p className="text-[12px] text-white/40">© {new Date().getFullYear()} Reinvente Mercadeo & Coaching Comercial. {t.footer.rights}</p>
          <p className="text-[11px] font-mono-tight text-white/35 uppercase tracking-[0.2em]">v1.0 · AI-Native Edition</p>
        </div>
      </div>
    </footer>
  );
}
